import { render, staticRenderFns } from "./CafeMenuItem.vue?vue&type=template&id=7ad94ad2"
import script from "./CafeMenuItem.vue?vue&type=script&lang=js"
export * from "./CafeMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports